var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"py-1",staticStyle:{"border-radius":"10px"},attrs:{"label":"","color":"secondary","text-color":"white"}},[_c('v-icon',{staticClass:"px-2"},[_vm._v("swap_horiz")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }